import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const ArchiveInteractionModal = ({ open, onClose, onConfirm, interaction }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Archive Interaction</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to archive this interaction
          {interaction?.summary ? `: "${interaction.summary}"` : ""}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="warning" variant="contained">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveInteractionModal;